export default __webpack_public_path__ + "static/bannerPubliMB-EC-a44f5af69ab1f0ef8edae10d918e844b.png";